import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { MonthlyActiveUserCountType } from "../../../redux/listing/listingTypes";

type AppProps = {
  tableHeaders: TableHeadersType[];
  data: [] | MonthlyActiveUserCountType[];
};

const MonthlyActiveUserCountTable = ({ tableHeaders, data }: AppProps) => {
  return (
    <>
      {data?.map((dataItem: any) => {
        return (
          <tr className="text-left">
            {tableHeaders?.length &&
              tableHeaders?.map((item: any) => {
                if (dataItem[item?.value]) {
                  return (
                    <td
                      className={`${
                        dataItem[item?.value] == 0 ? `text-danger` : ""
                      }`}
                    >
                      {dataItem[item?.value]}
                    </td>
                  );
                } else {
                  return <td> --/-- </td>;
                }
              })}
          </tr>
        );
      })}
    </>
  );
};

export default MonthlyActiveUserCountTable;
